import React, { CSSProperties, useMemo } from 'react';

import { useCurrentLayout } from '@wp-block-builder/stores/BlockLayoutStore';

import { TBlock } from '../types';

import getBlockIconComponent from './getBlockIconComponent';

type TProps = {
  type: TBlock['type'];
  height: number;
};

const ICON_SX = {
  fontSize: 'small',
  color: 'inherit',
};

function InternalBlockPlaceholder({ type, height }: TProps) {
  const IconComponent = getBlockIconComponent(type);
  const style = useMemo<CSSProperties>(
    () => ({
      width: '100%',
      height,
      bgcolor: 'rgba(0,0,0, 0.05)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }),
    [height]
  );

  return (
    <div style={style}>
      <IconComponent sx={ICON_SX} />
    </div>
  );
}

type Props = {
  type: TBlock['type'];
};
export default function BlockPlaceholder({ type }: Props) {
  const currentLayout = useCurrentLayout();

  switch (type) {
    case 'Avatar':
      return <InternalBlockPlaceholder type="Avatar" height={48} />;
    case 'Button':
      return <InternalBlockPlaceholder type="Button" height={48} />;
    case 'ColumnsSection':
      return <InternalBlockPlaceholder type="ColumnsSection" height={48} />;
    case 'Container':
      return <InternalBlockPlaceholder type="Container" height={48} />;
    case 'ContainerYield':
      return <InternalBlockPlaceholder type="ContainerYield" height={80} />;
    case 'Divider':
      return <InternalBlockPlaceholder type="Divider" height={24} />;
    case 'Heading':
      return <InternalBlockPlaceholder type="Heading" height={24} />;
    case 'Html':
      return <InternalBlockPlaceholder type="Html" height={24} />;
    case 'Image':
      if (currentLayout === 'column') {
        return <InternalBlockPlaceholder type="Image" height={80} />;
      }
      return <InternalBlockPlaceholder type="Image" height={320} />;
    case 'LoopContainer':
      return <InternalBlockPlaceholder type="LoopContainer" height={48} />;
    case 'ProgressBar':
      return <InternalBlockPlaceholder type="ProgressBar" height={24} />;
    case 'Spacer':
      return <InternalBlockPlaceholder type="Spacer" height={24} />;
    case 'Text':
      return <InternalBlockPlaceholder type="Text" height={24} />;
  }
}
